import LineTagIcon from 'LuxKit/Icons/line/LineTagIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import config from 'constants/config'
import { getTourCampaignTier, isTourCampaignActive } from 'constants/tours'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const TourCampaignPromotionLabel = styled(PromotionLabel)`
  &&& {
    background-color: #ACEAE3;
    border-color: #ACEAE3;
    color: #003d37;
  }

  &&& > svg,
  &&& > * {
    color: #003d37;
  }
`

interface Props {
  className?: string
  campaignTags?: Array<string>
}

function TourCampaignTravelTagLabel({ campaignTags, className }: Props) {
  const intl = useIntl()
  const region = useAppSelector(state => state.geo.currentRegionCode)
  const isTourCampaignEnabled = isTourCampaignActive(region, config.BRAND)

  if (!isTourCampaignEnabled) {
    return null
  }

  const tier = getTourCampaignTier(campaignTags, intl)

  if (!tier) {
    return null
  }

  return <TourCampaignPromotionLabel className={className} icon={<LineTagIcon />}>{tier.tag}</TourCampaignPromotionLabel>
}

export default TourCampaignTravelTagLabel
